import axios from 'axios';

const server = "http://localhost:8000/api/"

export async function fetchBox(id, parent = "") {

    return await getBox(id).catch((error) => {
        throw new Error('Failed to get Box')
    })
}
async function getBox(id) {
    const responseGet = await fetch(server + "box/" + id.substring(1) + "/ ")
    if (responseGet.ok) return responseGet.json()
    throw new Error('Failed to get Box')
}
async function putBox(id, parent) {
    const responseCreate = await axios.post(server + "box/", {
        parent: parent ? parent : parent.substring(1),
        id: id.substring(1)
    })
    if (responseCreate.status == 269) return responseCreate
    throw new Error('Failed to create Box')
}

export async function fetchItem(id) {
    const responseGet = await fetch(server + "item/" + id.substring(1) + "/ ")
    if (responseGet.ok) return responseGet.json()
    throw new Error('Failed to get Item')
}

export async function addChild({ parent, id }) {
    const itemType = id.charAt(0) == "b" ? "box/" : "item/"
    const response = await axios.post(server + itemType, {
        parent: parent.substring(1),
        id: id.substring(1)
    }).catch((error) => {
        throw new Error('Failed to create child: ' + error)
    })

    return response.data
}

export async function deleteThing(id) {
    const itemType = id.charAt(0) == "b" ? "box/" : "item/"

    const response = await axios.delete(server + itemType + id.substring(1) + "/").catch((error) => {
        throw new Error('Failed to Delete Box: ' + error)
    })

    return response.data
}

/**
 * 
 * @param {string} id 
 * @param {object} data 
 * @returns 
 */
export async function updateThing({ id, data, error = "" }) {
    const itemType = id.charAt(0) == "b" ? "box/" : "item/"
    const response = await axios.put(server + itemType + id.substring(1) + "/", data).catch(() => { throw new Error("Failed to perform Update: " + error) })
    return response.data
}
